/**
 * @format
 */

// 1. Importa 'createRoot' del paquete 'react-dom/client'
import { createRoot } from 'react-dom/client';
import App from './App.web.tsx';

// const WEB_CLIENT_ID = '574407864279-bsr4d4ig72prrggro244ipj4h3nfj320'; // 🛑 REEMPLAZA ESTO
// 2. Busca el contenedor del DOM
const container = document.getElementById('root');

// 3. Crea una "raíz" de React
const root = createRoot(container);

// 4. Renderiza la aplicación en la raíz
root.render(
        <App />
);